import {computed, inject} from '@angular/core';
import {patchState, signalStore, withComputed, withMethods, withProps} from '@ngrx/signals';
import {descendingNotifications} from 'src/app/app.config';
import {Notification} from "src/app/infrastructure/moovement-api/models/notification";
import {AssetsStore} from 'src/app/domain/assets/assets.store';
import {removeEntity, setAllEntities, withEntities} from '@ngrx/signals/entities';

export const NotificationsStore = signalStore(
  { providedIn: 'root' },
  withEntities<Notification>(),
  withProps(() => {
    return {
      assetsStore: inject(AssetsStore)
    }
  }),
  withComputed(({ entities, assetsStore }) => ({
    sortedNotifications: computed(() => {
      const assetsById = assetsStore.assetsById();

      return entities()
        .filter(notification => notification.assetId && assetsById.has(notification.assetId))
        .filter(notification => notification.dismissalTime == undefined)
        .sort(descendingNotifications())
    })
  })),
  withMethods((store) => ({
    setAllEntities(notifications: Notification[]) {
      patchState(store, setAllEntities(notifications));
    },
    remove(notificationId: string) {
      patchState(store, removeEntity(notificationId));
    }
  })
));
